'use es6';

export var UNAUTHORIZED_MESSAGE = 'unauthorized';
export function maybeGetParentIframe() {
  try {
    if (window.self !== window.top) {
      return window.top;
    }
  } catch (e) {
    return null;
  }

  return null;
}